import { isBrowser } from "utils/infrastructure/ssg-utils"

export function getHostname(url: string) {
    return isBrowser() ? new URL(url).hostname : null
}
